import React, { Fragment } from 'react';

import SortableColumnHeader from '../../../../../components/sortable-column-header/sortable-column-header';

const SortableTableHeader = ({ header, sortBy, changeSort, customStyle = {} }) => (
  <div className="sortable-auspices-table-header" style={customStyle}>
    <SortableColumnHeader
      text={header}
      direction={sortBy.category === header ? (sortBy.direction === 'ASC' ? 1 : -1) : 0}
      onClick={changeSort}
    />
  </div>
);

const UnSortableTableHeader = ({ header, customStyle = {} }) => (
  <div className="unsortable-auspices-table-header" style={{ ...customStyle }}>
    <span>{header}</span>
  </div>
);

export const GroupByHeaders = ({ groupBySort, changeGroupBySort, sortBy, changeSort, groupByTerm, positionLabel = 'Auspice' }) => {
  const orderedHeaders = [
    {
      type: {
        groupedBy: (
          <SortableTableHeader header={positionLabel} sortBy={groupBySort} changeSort={() => changeGroupBySort(positionLabel)} />
        ),
        displayed: (
          <SortableTableHeader
            header={positionLabel}
            sortBy={sortBy}
            changeSort={() => changeSort(positionLabel)}
            customStyle={{ flex: 0.19 }}
          />
        ),
      },
    },
    {
      status: {
        displayed: (
          <SortableTableHeader
            header="Role Status"
            sortBy={sortBy}
            changeSort={() => changeSort('Role Status')}
            customStyle={{ flex: 0.19 }}
          />
        ),
        groupedBy: (
          <SortableTableHeader header="Role Status" sortBy={groupBySort} changeSort={() => changeGroupBySort('Role Status')} />
        ),
      },
    },

    {
      person: {
        displayed: (
          <SortableTableHeader
            header="Person"
            sortBy={sortBy}
            changeSort={() => changeSort('Person')}
            customStyle={{ flex: 0.28 }}
          />
        ),
        groupedBy: (
          <SortableTableHeader
            header="Person"
            sortBy={groupBySort}
            changeSort={() => changeGroupBySort('Person')}
            customStyle={{ flex: 0.28 }}
          />
        ),
      },
    },
    {
      agency: {
        displayed: <SortableTableHeader header="Agency" sortBy={sortBy} changeSort={() => changeSort('Agency')} />,
        groupedBy: (
          <SortableTableHeader header="Agency" sortBy={groupBySort} changeSort={() => changeGroupBySort('Agency')} />
        ),
      },
    },
    {
      notes: {
        displayed: <UnSortableTableHeader header="Notes" customStyle={{ paddingRight: '20px' }} />,
      },
    },
    {
      actions: {
        displayed: <UnSortableTableHeader header="Actions" customStyle={{ textAlign: 'end', paddingRight: '15px' }} />,
      },
    },
  ];

  orderedHeaders.sort((a, b) => {
    if (a[groupByTerm] === b[groupByTerm]) return 0;
    return a[groupByTerm] ? -1 : 1;
  });
  return (
    <div className="auspices-table-header-container">
      {orderedHeaders.map((possibleComponents, idx) => {
        const { groupedBy, displayed } = Object.values(possibleComponents)[0];
        if (idx === 0 && groupedBy) {
          return <Fragment key={idx}>{groupedBy}</Fragment>;
        }
        return <Fragment key={idx}>{displayed}</Fragment>;
      })}
    </div>
  );
};
